// Legacy alias — canonical route is /automations/steps/create.
import { Redirect, useLocalSearchParams } from 'expo-router';

export default function CreateStepAlias() {
    const params = useLocalSearchParams();
    return <Redirect href={{ pathname: '/automations/steps/create', params }} />;
}
